<ul class="nav nav-tabs" [class.has-counters]="hasCounters">
  @for (tab of formTab.items; track tab; let i = $index) {
    <li class="nav-item">
      <div>
        <a
          class="nav-link"
          [ngClass]="{ active: tab.active }"
          (click)="activateTab(tab, i)"
          >{{ tab.label }}</a
        >
        @if (tab?.counter) {
          <app-counter-badge
            [count]="$safeNavigationMigration(tab?.counter)"
          ></app-counter-badge>
        }
      </div>
    </li>
  }
</ul>
